/* eslint-disable jsx-a11y/alt-text */
import logo from "../../assets/images/newlogo2.png";
import fb from "../../assets/images/fb.png";
import twiter from "../../assets/images/twiter.png";
import link from "../../assets/images/link.png";
import insta from "../../assets/images/insta.png";
import phone from "../../assets/images/ph.png";
import mail from "../../assets/images/mail.png";
import address from "../../assets/images/loc.png";
import you from "../../assets/images/you.png";
import styles from "../footer/Footer.module.scss";
import { MdCall } from "react-icons/md";
import { AiOutlineMail } from "react-icons/ai";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleInputChange = (e: any) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidEmail(emailRegex.test(newEmail));
  };

  const handleButtonClick = () => {
    setEmail("");
  };

  // Function to update the state with the current screen width
  const updateScreenWidth = () => {
    setScreenWidth(window.innerWidth);
  };

  // Add an event listener to update the width when the window is resized
  useEffect(() => {
    window.addEventListener("resize", updateScreenWidth);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  useEffect(() => {
    if (email === "") {
      setIsValidEmail(true);
    }
  }, [email]);

  return (
    <>
      <div className={styles.mainheader}>
        <div className="container">
          <div className="row">
            <div className={styles.footer}>
              <div className="col-lg-5">
                {" "}
                <div className={styles.left}>
                  <div className={styles.logo}>
                    <div className={styles.image}>
                      <img src={logo} />
                    </div>
                    <div className={styles.inspection}>
                      <p>THE INSPECTION</p>
                      <span className={styles.cid}>COMPANY</span>
                    </div>
                  </div>
                  <div className={styles.contact}>
                    <span className={styles.us}>Contact us: </span>
                    <span className={styles.num}>
                      <a href="tel:+1973-449-4171">
                        <span className={styles.ph}>
                          <img src={phone} />
                          973-449-4171
                        </span>
                      </a>
                    </span>
                    <span className={styles.mail}>
                      <img src={mail} /> sales@constructioncodeinspections.com
                    </span>
                    <span className={styles.address}>
                      <span>
                        <img src={address} alt="" />
                      </span>{" "}
                      460 Bloomfield Avenue, Montclair NJ 07006
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                {" "}
                <div className={styles.right}>
                  <div className={styles.subs}>Subscribe now!</div>
                  {/* <div className={styles.input}>
                    <input
                      placeholder="Enter your email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    ></input>
                    <div className={styles.input_btn}>
                      <button
                        onClick={() => {
                          setEmail("");
                        }}
                      >
                        SUBSCRIBE
                      </button>
                    </div>
                  </div> */}
                  <div
                    className={`${"d-flex justify-content-center"} ${
                      styles.new_input
                    } `}
                  >
                    <div className="input-group w-auto mt-2">
                      <input
                        type="text"
                        className={`form-control ${
                          !isValidEmail ? "is-invalid" : ""
                        }`}
                        placeholder="Enter your email"
                        name="email"
                        value={email}
                        onChange={handleInputChange}
                        aria-label="Example input"
                        aria-describedby="button-addon1"
                      />
                      <button
                        className={styles.btn_new}
                        type="button"
                        id="button-addon1"
                        onClick={handleButtonClick}
                        disabled={!isValidEmail}
                        data-mdb-ripple-color="dark"
                      >
                        Subscribe
                      </button>
                    </div>
                    {!isValidEmail && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          width: "100%",
                        }}
                      >
                        Please enter a valid email
                      </div>
                    )}
                  </div>
                  {/* <div className={styles.contact}>
                    <span className={styles.us}>Contact us on </span>
                    <span className={styles.num}>
                      <a href="tel:+61999422222413">
                        <span className={styles.ph}>
                          <MdCall /> +1-212-456-7890
                        </span>
                      </a>
                    </span>
                    <span className={styles.mail}>
                      <AiOutlineMail /> info@gmail.com
                    </span>
                    <span className={styles.address}>
                      <span>
                        <img src={address} alt="" />
                      </span>{" "}
                      19141 Pine Ridge Circle, Anchorage AK
                    </span>
                  </div> */}
                  <div className={styles.main_logo}>
                    <p>Follow us -</p>
                    {screenWidth <= 575 ? (
                      <div className={styles.logos}>
                        <span>
                          <img src={fb} />
                        </span>
                        {/* <span>
                        <img src={twiter} />
                      </span> */}
                        <span>
                          <img src={link} />
                        </span>
                        <span>
                          <img src={you} />
                        </span>
                        {/* <span>
                        <img src={insta} />
                      </span> */}
                      </div>
                    ) : (
                      <div className={styles.logos}>
                        <span>
                          <img src={fb} />
                        </span>
                        {/* <span>
                      <img src={twiter} />
                    </span> */}
                        {/* <span>
                        <img src={you} />
                      </span> */}
                        <span>
                          <img src={link} />
                        </span>
                        <span>
                          <img src={insta} />
                        </span>
                      </div>
                    )}
                  </div>

                  <div>
                    <Link to="/terms">Terms of service</Link> |{" "}
                    <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                    <Link to="/copyRight">Copyright Policy</Link>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <hr /> */}
      <div className="container">
        <div className="row">
          <div className={styles.underline}>
            <div className={styles.cid}>
              @2024 Construction Code Inspections LLC
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
